/* eslint-disable no-unused-vars */
import axios from "axios";
import store from "../store";

const baseURL = process.env.VUE_APP_BASE_URL;

const getCookie = (cookieName, parse = false) => {
  let allCookies = document.cookie.split(";");
  for (let i = 0; i < allCookies.length; i++) {
    let cookie = allCookies[i].split("=");
    if (cookie[0].trim() === cookieName) {
      return parse ? JSON.parse(cookie[1]) : cookie[1];
    }
  }
};

const removeCookie = name => {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var cookieName = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (cookieName.trim() === name) {
      var date = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = `${cookieName.trim()}=;${date};path=/;`;
    }
  }
};

const getHeaders = () => {
  let headers = { "Content-Type": "application/json" };

  if (getCookie("oe_jwt")) {
    headers = {
      Authorization: `Bearer ${getCookie("oe_jwt")}`,
      "Content-Type": "application/json",
    };
  }
  return headers;
};

export const getSequencer = () => {
  const sequencer = store.getters.storeSequencial || {};

  return sequencer;
};

export const getLocale = () => {
  return getCookie("elevenAdminLocale").substring(0, 2) || "pt";
};

export const axiosPublic = axios.create({
  baseURL,
});

export const axiosPrivate = axios.create({
  baseURL,
});

export const axiosPrivateFormData = axios.create({
  baseURL,
});

axiosPrivate.interceptors.request.use(function (config) {
  config.headers = getHeaders();
  config.headers["Content-Type"] = "application/json";

  return config;
});

axiosPrivate.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status === 403) {
      removeCookie("oe_jwt");
    }

    if (error.response.data.message === "Expired token") {
      removeCookie("oe_jwt");
      return;
    }

    store.commit("showSnackbar", {
      variant: "error",
      message: error.response.data.message,
    });
    return Promise.reject(error);
  }
);

axiosPrivateFormData.interceptors.request.use(function (config) {
  config.headers = getHeaders();
  config.headers["Response-Encoding"] = "utf8";
  config.headers["Response-Type"] = "arraybuffer";
  config.headers["Content-Type"] = "application/json";

  return config;
});

export const getStores = () =>
  axiosPrivate.post("loja/listar", { cache: true });

// export const exampleRequest = () => axiosPrivate.get("get/endpoint");

// export * from "./apiModule"; <- example of how to export all functions from a file

export * from "./producers";
export * from "./dash";
export * from "./events";
export * from "./sales";
export * from "./reports";
export * from "./orderEvents";
export * from "./combo";
export * from "./invitation";
export * from "./affiliates";
export * from "./digitalWallet";
